<script lang="ts">
	import Button from '$lib/shadcn/ui/button/button.svelte'
	import Ccby from '$lib/svg/CCBY.svelte'
	import Ccnc from '$lib/svg/CCNC.svelte'
	import Ccnd from '$lib/svg/CCND.svelte'
	import Ccpd from '$lib/svg/CCPD.svelte'
	import Ccsa from '$lib/svg/CCSA.svelte'
	import { Book, Check, Copy } from 'lucide-svelte'

	export let name: string
	export let code: string
	export let url: string
	export let realname: string

	let copied = false
	async function copy() {
		await navigator.clipboard.writeText(
			`"${name}" by ${realname} licensed ${code} from Scenery.io`,
		)
		copied = true
		setTimeout(() => (copied = false), 1200)
	}
</script>

<div>
	<h3>
		Licensed <a href={url} class="text-green-400 font-semibold"
			>{code === 'STDL' ? 'Standard License' : code}</a
		>
	</h3>
	<ul
		class="text-sm text-muted-foreground leading-tight mt-2 mb-4 ml-1 flex flex-col gap-2"
	>
		{#if code.includes('CC0')}
			<li class="flex gap-2 items-center">
				<div class="flex-shrink-0 w-4 h-4"><Ccpd /></div>
				This asset is public domain
			</li>
		{/if}
		{#if code.includes('BY')}
			<li class="flex gap-2 items-center">
				<div class="flex-shrink-0 w-4 h-4"><Ccby /></div>
				Credit must be given to {realname}
			</li>
		{/if}
		{#if code.includes('NC')}
			<li class="flex gap-2 items-center">
				<div class="flex-shrink-0 w-4 h-4"><Ccnc /></div>
				Only noncommercial uses are permitted
			</li>
		{/if}
		{#if code.includes('ND')}
			<li class="flex gap-2 items-center">
				<div class="flex-shrink-0 w-4 h-4"><Ccnd /></div>
				No derivatives or adaptations are permitted
			</li>
		{/if}
		{#if code.includes('SA')}
			<li class="flex gap-2 items-center">
				<div class="flex-shrink-0 w-4 h-4"><Ccsa /></div>
				Adaptations must be shared under the same terms
			</li>
		{/if}
		{#if code.includes('STDL')}
			<li class="flex gap-2 items-center">
				No sharing or redistribution allowed
			</li>
			<li class="flex gap-2 items-center">
				Derivatives or adaptations are permitted
			</li>
			<li class="flex gap-2 items-center">
				<a
					href="/license#refunds"
					class="text-green-500 hover:underline font-medium"
					>Refund policy
				</a>
			</li>
		{/if}
	</ul>
	<div class="flex flex-wrap gap-1 items-center">
		<Button variant="outline" size="sm" href={url}>
			<Book class="mr-2 h-4 w-4" />
			Read License
		</Button>
		<Button variant="outline" size="sm" on:click={copy}>
			{#if !copied}
				<Copy class="mr-2 h-4 w-4" />
			{:else}
				<Check class="mr-2 h-4 w-4" />
			{/if}
			Copy Credits
		</Button>
	</div>
</div>
